export default IconSquaresFilled => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-squares-filled" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z" />
  <path d="M8 14.5l6.492 -6.492" />
  <path d="M13.496 20l6.504 -6.504l-6.504 6.504z" />
  <path d="M8.586 19.414l10.827 -10.827" />
  <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
</svg>`;